// ############################ Imported from Old UI ###########################

export interface IImageIcon {
  icon: string;
  width?: number;
  height?: number;
  color?: string;
  left?: number;
  top?: number;
}

export function imageIcon({ icon, width = 20, height = 20, color = 'black', left = 0, top = 0 }: IImageIcon) {
  return {
    display: 'inline-block',
    width,
    height,
    content: '""',
    color,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: `${left}px ${top}px`,
    backgroundSize: `${width}px ${height}px`,
    backgroundImage: `url(${icon})`,
  };
}

export function materialIcon(icon: string, size: number = 20, color: string = 'black') {
  return `
      content: '${icon}';
      font-size: ${size}px;
      color: ${color};
      font-family: 'Material Icons';
      font-weight: normal;
      font-style: normal;
      display: inline-block;
      line-height: 1;
      text-transform: none;
      letter-spacing: normal;
      word-wrap: normal;
      white-space: nowrap;
      direction: ltr;

      /* Support for all WebKit browsers. */
      -webkit-font-smoothing: antialiased;
      /* Support for Safari and Chrome. */
      text-rendering: optimizeLegibility;

      /* Support for Firefox. */
      -moz-osx-font-smoothing: grayscale;

      /* Support for IE. */
      font-feature-settings: 'liga';
    }
  `;
}
